import styled from 'styled-components';
export var SkeletonCard = styled.div.withConfig({
  displayName: "SkeletonCard",
  componentId: "sc-f06ki2-0"
})(["height:287px;margin-bottom:16px;"]);